module.exports = __webpack_public_path__ + "static/img/LOGO.2ead21b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/OBDUCTION/LOGO.png
// module id = BXbs
// module chunks = 0